import type { ConfigApiError } from '../../types/errors';

/**
 * Type guard to check if an error is a ConfigApiError.
 *
 * ConfigApiError is the shape of API error responses created by create-endpoint-fetch.
 * It contains an HTTP status code and optional array of detailed errors.
 */
export const isConfigApiError = (error: unknown): error is ConfigApiError =>
  error != null &&
  typeof error === 'object' &&
  'status' in error &&
  typeof (error as ConfigApiError).status === 'number';
